import { render } from "./caseView.vue?vue&type=template&id=5f69f1c0&scoped=true"
import script from "./caseView.vue?vue&type=script&lang=js"
export * from "./caseView.vue?vue&type=script&lang=js"

import "./caseView.vue?vue&type=style&index=0&id=5f69f1c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f69f1c0"]])

export default __exports__